<template>
  <Bubble>
    <div class="row">
      <div class="col">
        <router-link to="/projekt/prozess">Prozessübersicht</router-link>
        <br />
        <br />
        <div class="timeline">
          <div class="timeline-item" v-for="(item, i) in items" :key="i">
            <span class="badge" v-if="item.machmit">Mach Mit!</span>
            {{" "}}
            <router-link :to="item.path">{{ item.title }}</router-link>
            <svg class="circle" height="10" width="10" viewBox="0 0 10 10">
              <circle cx="5" cy="5" r="5" stroke="none" stroke-width="0" fill="black" />
            </svg>
          </div>
          <svg class="triangle" height="10" width="10" viewBox="0 0 10 10">
            <path d="M0 0 L5 10 L10 0 Z" />
          </svg>
        </div>
      </div>
      <router-view></router-view>
    </div>
  </Bubble>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      items: [
        {
          title: "Interaktive Karte",
          path: "/projekt/machmit/karte",
          machmit: true
        },
        {
          title: "Auswertung Interaktive Karte",
          path: "/projekt/machmit/auswertung",
          machmit: true
        },
        {
          title: "Grundlagenermittlung",
          path: "/projekt/info",
          machmit: false
        },
        {
          title: "DREHBUCH I: Auszüge aus dem Bericht",
          path: "/projekt/bericht",
          machmit: false
        },
        {
          title: "Ergebnisse Bürgerbeteiligung",
          path: "/projekt/mitwirkung",
          machmit: true
        },
        {
          title: "Dokumentation Arbeitsgruppe",
          path: "/projekt/arbeitsgruppe",
          machmit: false
        },
        {
          title: "Präsentation Online Umfrage",
          path: "/projekt/machmit/umfrage",
          machmit: true
        },
        {
          title: "Dokumentation Online Umfrage",
          path: "/projekt/onlineumfrage",
          machmit: false
        },
        // {
        //   title: "Film über den Prozess",
        //   path: "/projekt/video",
        //   machmit: false
        // },
        {
          title: "Dokumentation Bürgerwerkstatt",
          path: "/projekt/buergerwerkstatt",
          machmit: false
        },
        {
          title: "Ideenbaum",
          path: "/projekt/machmit/ideenbaum",
          machmit: true
        },
        {
          title: "Leitbildentwurf",
          path: "/projekt/leitbild",
          machmit: false
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.timeline {
  position: relative;
  .triangle {
    position: absolute;
    left: -3.75px;
    fill: #b8c2d6;
  }
  .timeline-item {
    padding: 10px;
    padding-top: 0;
    position: relative;
    border-left: 2px solid #b8c2d6;
    .circle {
      position: absolute;
      top: 0;
      left: -5.75px;

      circle {
        fill: #b8c2d6;
      }
    }
  }
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
  li {
    margin: 10px 15px;
  }
}
a {
  text-transform: uppercase;
  &:hover {
    font-weight: inherit;
    text-decoration: underline;
  }
}

.title {
  text-transform: uppercase;
  background: #b3db11;
  color: #1b4c88;
}
.badge {
  text-transform: uppercase;
  color: white;
  background: #1b4c88;
}
</style>

